import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
    createStyles({
        ttServiceSections: {
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(2),
        },
        ttSectionBox: {
            border: '1px solid #D6DDE2',
            borderRadius: 4,
            backgroundColor: '#FFFFFF',
            padding: theme.spacing(2),
        },
        ttSectionTitle: {
            fontWeight: 600,
            fontSize: 15,
            color: '#107A98',
            marginBottom: theme.spacing(1.5),
        },
        ttField: {
            marginBottom: theme.spacing(2),
        },
        ttFieldsGrid: {
            '& $ttField': {
                marginBottom: 0,
                '& .MuiTypography-root': {
                    marginBottom: theme.spacing(0.25),
                },
            },
            '& .MuiGrid-item': {
                paddingTop: theme.spacing(0.25),
                paddingBottom: theme.spacing(0.25),
            },
        },
        ttSelect: {
            backgroundColor: '#FFFFFF',
            width: '100%',
        },
        ttAuthorizationNotesField: {
            marginTop: theme.spacing(2),
        },
    }),
);
